import React from "react";

export const Card = ({ children, className = "" }) => (
  <div
    className={`
      rounded-2xl p-4 shadow-lg transition-all duration-300
      border border-transparent hover:border-indigo-500
      hover:shadow-indigo-500/50
      bg-white dark:bg-zinc-900 dark:text-white
      ${className}
    `}
    style={{
      boxShadow: "0 4px 20px rgba(99, 102, 241, 0.3)",
    }}
  >
    {children}
  </div>
);

export const CardContent = ({ children, className = "" }) => (
  <div className={`text-base text-gray-800 dark:text-gray-200 ${className}`}>
    {children}
  </div>
);
